export default __webpack_public_path__ + "static/media/732623f3186630fb84a6a459a2c0773.2f683258.png";